class TrayHotspotShowcase extends HTMLElement {
  connectedCallback() {
    this.hotspots = Array.from(this.querySelectorAll('[data-tray-hotspot]'));
    this.hotspots.forEach((hotspot) => {
      hotspot.addEventListener('click', this.onHotspotClick.bind(this, hotspot));
    });
    this.addEventListener('pointerdown', this.onFramePointerDown.bind(this));
  }

  isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  onHotspotClick(hotspot, event) {
    if (this.isTouch() && !hotspot.classList.contains('is-active')) {
      event.preventDefault();
      this.setActive(hotspot);
    }
  }

  onFramePointerDown(event) {
    if (!event.target.closest('[data-tray-hotspot]')) {
      this.clearActive();
    }
  }

  setActive(hotspot) {
    this.hotspots.forEach((h) => h.classList.toggle('is-active', h === hotspot));
  }

  clearActive() {
    this.hotspots.forEach((h) => h.classList.remove('is-active'));
  }
}

if (!customElements.get('tray-hotspot-showcase')) {
  customElements.define('tray-hotspot-showcase', TrayHotspotShowcase);
}
